///ts:ref=UIWindow
/// <reference path="./UIWindow.ts"/> ///ts:ref:generated

class RepairShop extends UIWindow {
	panel: PIXI.Sprite;
	base: Base;

	upgrade: BuyButton;
	repair: BuyButton;
	level: PIXI.Text;

	constructor() {
		super();
		this.visible = false;

		this.panel = new PIXI.Sprite(Assets.ui.panel_small);
		centerFrickingSprite(this.panel);
		this.addChild(this.panel);

		this.upgrade = new BuyButton(Assets.ui.upgrade);
		this.upgrade.position.set(48, 0);
		this.addChild(this.upgrade);

		this.repair = new BuyButton(Assets.ui.repair);
		this.repair.position.set(-48, 0);
		this.addChild(this.repair);

		this.level = new PIXI.Text("1", StatBar.textStyle);
		this.level.position.set(0, -30);
		this.addChild(this.level);

		this.upgrade.btn.onClick.addListener(() => {
			const base = this.base;
			if (!base) return;
			if (this.upgrade.checkTutor()) {
				return;
			}
			base.upgrade();
			this.hide();
		});

		this.repair.btn.onClick.addListener(() => {
			const base = this.base;
			if (!base) return;
			if (this.repair.checkTutor()) {
				return;
			}
			base.repair();
			this.hide();
		});
	}

	show(base: Base) {
		//set upgrade and repair cost here
		let price = -Upgrades.getUpgradeDict(base.building.dict).price;
		this.upgrade.cost = price + "";
		price = (-base.building.price / 2) | 0;
		this.repair.cost = price + "";
		this.level.text = base.building.dict.level + "";
		centerFrickingSprite(this.level);

		Interact.showWnd(this);
		this.base = base;
		this.position.set(base.position.x - 48, base.position.y);
		this.visible = true;

		this.update();
	}

	hide() {
		Interact.hideWnd(this);
		this.base = null;
		this.visible = false;
	}

	update() {
		this.repair.update();
		this.upgrade.update();
	}
}
